import { Helmet } from "react-helmet";

export const TsHelmet = Helmet as any;
